import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LeavePlan from "..";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../Assets/Images/aaa.png";
import { ReducersTypes } from "../../../../../../../Constants";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  leavename: "",
  leaveid: null,
  isprobationaccurallimit: false,
  creditlimitinnonaccural: 0,
  isaccrual: false,
};
class LeaveBalance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };
  }

  componentWillMount() {
    this.SetValues(this.props);
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () => {
        this.SetValues(props);
      });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      const { InitLeavesPolicy } = props;
      this.setState({
        ParentIndex,
        leavetypeid: props.leavetypeid,
        leavename: InitLeavesPolicy.policy[ParentIndex].leavename,
        isaccrual: InitLeavesPolicy.policy[ParentIndex].isaccrual,
        isprobationaccurallimit:
          InitLeavesPolicy.policy[ParentIndex].isprobationaccurallimit,
        creditlimitinnonaccural:
          InitLeavesPolicy.policy[ParentIndex].creditlimitinnonaccural,
      });
    } else {
      this.setState({ ...ParentState });
    }
  }

  setHelperText = (key) => {
    this.props.setHelperText({
      helperText: this.props.Language
        ? this.props.Language.extratimepolicy[key]
        : "",
    });
  };

  handleChange(name, ...arg) {
    switch (name) {
      case "isaccrual":
        this.setState(
          {
            [name]: arg[0],
            isprobationaccurallimit: false,
            creditlimitinnonaccural: 0,
          },
          () => this.UpdateReducer(),
        );
        break;
      case "isprobationaccurallimit":
        this.setState({ [name]: arg[0], creditlimitinnonaccural: 0 }, () => {
          this.UpdateReducer();
        });
        break;
      default:
        break;
    }
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      isaccrual: this.state.isaccrual,
      isprobationaccurallimit: this.state.isprobationaccurallimit,
      creditlimitinnonaccural: this.state.creditlimitinnonaccural,
    };
    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  CommonNumberChange = (name, max, event) => {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (
        Number(event.target.value) > Number(max)
        || Number.isNaN(event.target.value)
      ) {
        value = this.state[name];
      } else value = Number(event.target.value);
      this.setState({ [name]: value }, () => this.UpdateReducer());
    }
  };

  render() {
    const language = this.props.Language.extratimepolicy;
    return (
      <IntlProvider locale="en" messages={language}>
        {/* 4 */}
        <div className="margin-top-20">
          <div className="inner-wrapper opaque">
            {/* <div class="form-group"> */}
            <p className="form-sub-header">
              <FormattedMessage
                id="LbAvailableForUse"
                defaultMessage="When will the leave balance be available for employees to use?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isaccrual", false)}
              aria-expanded={this.state.isaccrual == false}
            >
              <span>
                {" "}
                <FormattedMessage
                  id="LbCreditedAtOnce"
                  defaultMessage="Leave balance will be credited all at once"
                />
              </span>
              {this.state.isaccrual == false ? (
                <span className="floatright">
                  {" "}
                  <img src={CheckImg} height="20" />{" "}
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            {/* <div className="et-level2">
              <Collapse
                in={this.state.isaccrual == false}
                timeout="auto"
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="__LbCreditDuringProbation"
                    defaultMessage="Do you want to limit credit during probation?"
                  />
                </p>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("isprobationaccurallimit", true)}
                  aria-expanded={this.state.isprobationaccurallimit}
                >
                  <span>
                    <FormattedMessage id="LbYes" defaultMessage="Yes" />
                  </span>
                  {this.state.isprobationaccurallimit == true ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
                <div className="et-level3">
                  <Collapse
                    in={this.state.isprobationaccurallimit}
                    timeout="auto"
                    unmountOnExit
                    className="padding30 overflow-initial"
                  >
                    <FormattedMessage id="LbCreditOnly" defaultMessage="Credit only" />
                    <InputValues
                      min="0"
                      max="300"
                      field="creditlimitinnonaccural"
                      onChange={this.CommonNumberChange.bind(this, "creditlimitinnonaccural", 300)}
                      value={this.state.creditlimitinnonaccural}
                      defaultvalue={this.state.creditlimitinnonaccural}
                    />

                    <FormattedMessage
                      id="LbLeavesTillProbationEnd"
                      defaultMessage=" leave(s) until probation ends"
                    />
                  </Collapse>
                </div>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("isprobationaccurallimit", false)}
                  aria-expanded={!this.state.isprobationaccurallimit}
                >
                  <span>
                    <FormattedMessage id="LbNo" defaultMessage="No" />
                  </span>
                  {this.state.isprobationaccurallimit == false ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
              </Collapse>
            </div> */}
          </div>
        </div>
        {/* <Button variant="contained" color="primary" onClick={() => this.validateNext()}>
                        Next
                    </Button> */}
      </IntlProvider>
    );
  }
}
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(LeaveBalance)));
